/* v46 (15/10/2026) : copie de mm-taille-ajout-v31.js sous un NOM NEUF, textes pt et pl ajoutés. */
/* Mix & Match : un + pose sur l image de chaque carte, qui ouvre le choix de la taille.
 *
 * 20/09/2026, demande de Nicolas. Trois etapes dans la journee :
 *  1. les deux pastilles de taille servaient de boutons d ajout. Ca marchait, mais rien
 *     ne le disait : une pastille ressemble a un filtre. Nicolas a conclu qu on ne
 *     pouvait pas ajouter au panier.
 *  2. un bouton Ajouter explicite a ete pose sous les tailles.
 *  3. enleve ce bouton Ajouter et mets le plus au niveau de l image : le + vit
 *     desormais sur la photo, comme sur les pages collection.
 *
 * Ce qui n a PAS change, et qu il ne faut pas casser : le theme n a QU UN compteur par
 * carte, partage par les deux tailles, alors que le panier indexe ses lignes par identifiant
 * de VARIANTE. On repositionne donc le compteur sur la quantite deja au panier POUR LA
 * TAILLE VISEE avant de declencher le + du theme, ce qui laisse toute la logique de prix
 * et de remise en place.
 *
 * Aucun HTML n est ecrit en chaine ici : tout passe par createElement.
 *
 * ⚠️ AUCUN TEXTE VISIBLE N EST ECRIT EN DUR. Le 20/09/2026 Nicolas a vu Choisissez
 * la taille et au panier s afficher en francais sur les pages allemande, espagnole et
 * italienne. Tout passe maintenant par la table TEXTES et la fonction dire().
 *
 * ⚠️ LES COULEURS SONT CELLES DE LA CHARTE : creme #fefcee pour les fonds, rouille
 * #7d432d et son hover #67361f, encre #1c1c1c. Le #B5532A qui trainait ici etait une
 * rouille inventee, refusee par Nicolas.
 *
 * ⚠️ LE STOCK NE SE LIT PAS SUR LES BOUTONS RADIO. Mesure du 20/09/2026 sur le HTML
 * servi : les .variant-radio ne portent JAMAIS l attribut disabled, meme pour un modele
 * dont les deux tailles sont a zero. Le seul marqueur fiable est la classe
 * product-card__sold-out posee par le theme sur <product-card>. Ma premiere version
 * lisait radio.disabled : elle voyait donc tout le catalogue comme disponible, et la
 * fenetre laissait choisir une taille sur un modele epuise. Ne pas revenir en arriere.
 *
 * ⚠️ ET L ETIQUETTE DE RUPTURE N EST PAS POSEE ICI. J avais ajoute un .mm-epuise sur
 * la photo : il faisait doublon avec le badge que le theme rend deja, dans le titre de
 * la carte, ET que Shopify traduit tout seul (Sold out, Epuise, Ausverkauft, Agotado,
 * Esaurito). Le badge du theme est simplement repositionne et restyle dans
 * snippets/correctifs-ui-3.liquid, avec le retrait de l opacite a 50 % que le theme
 * appliquait a la photo. Ne pas recreer d etiquette ici.
 */
(function () {
  /* ⚠️ GARDE ANTI DOUBLE EXECUTION. Depuis le 21/09/2026 ce fichier est charge
     GLOBALEMENT par layout/theme.liquid, pour que le + existe sur toutes les pages
     collection et plus seulement sur le Mix & Match. La section Mix & Match le charge
     peut-etre encore de son cote : le navigateur ne telecharge qu une fois, mais il
     EXECUTE deux fois, ce qui doublerait les ecouteurs et poserait deux boutons. */
  if (window.__mmTailleAjout) return;
  window.__mmTailleAjout = 1;

  /* La carte d un produit. ATTENTION : [data-mix-match-bundle-main-items] est le
     CONTENEUR de toutes les cartes, pas une carte. L utiliser ici ne posait qu un
     seul bouton pour toute la page (constate le 20/09/2026). */
  var SEL_CARTE = 'product-card';
  var CLASSE_EPUISE = 'product-card__sold-out';
  var modale = null;

  var CSS = [
    /* 1. LE CENTRAGE DES PASTILLES. Elles etaient en display:inline-block, sur lequel  */
    /*    align-items et justify-content n ont aucun effet : 7 px restaient non repartis */
    /*    sous le texte, d ou l impression qu il remontait. Mesure du 20/09/2026.        */
    '.mix-bundle-left .product-variants .input-wapper label.variant-option,',
    '.mix-bundle-left .card--card.card--media>.card__content .tital-main-wapper',
    ' .product-variants .input-wapper label.variant-option{',
    'display:inline-flex !important;align-items:center;justify-content:center;',
    'text-align:center;}',
    /* 2. Les pastilles restent dans le DOM (le script s en sert) mais sortent de l ecran. */
    '.mix-bundle-left .product-variants{position:absolute;width:1px;height:1px;',
    'overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;}',
    /* 3. Le + pose SUR l image, comme sur les pages collection. */
    '.mm-media{position:relative;}',
    '.mm-add{position:absolute;right:10px;bottom:10px;z-index:3;',
    'display:inline-flex;align-items:center;justify-content:center;',
    'width:40px;height:40px;padding:0;border:0;border-radius:999px;',
    'background:#7d432d;color:#ffffff;font-size:15px;font-weight:600;line-height:1;',
    'cursor:pointer;-webkit-appearance:none;appearance:none;',
    'box-shadow:0 2px 10px rgba(0,0,0,.18);}',
    '.mm-add:hover{background:#67361f;}',
    /* LE + RESTE TOUJOURS VISIBLE. Nicolas, 20/09/2026 : a certains endroits il n y a  */
    /* pas le plus, on est simplement sur un rond rouille, il faut qu il y ait le plus. */
    /* Avant, des qu une paire etait au panier le + etait masque et remplace par le     */
    /* nombre : un rond avec un seul chiffre fin se lisait comme un rond vide. Le       */
    /* compteur passe donc dans une pastille en coin, et le + ne bouge plus.            */
    '.mm-add__plus{font-size:22px;line-height:1;font-weight:600;color:#ffffff;}',
    '.mm-add--actif{background:#67361f;}',
    '.mm-add__txt{position:absolute;top:-5px;right:-5px;box-sizing:border-box;',
    'min-width:19px;height:19px;padding:0 5px;display:none;',
    'align-items:center;justify-content:center;border-radius:999px;',
    'background:#fefcee;color:#7d432d;border:1px solid #7d432d;',
    'font-size:11px;font-weight:700;line-height:1;}',
    '.mm-add--actif .mm-add__txt{display:flex;}',
    /* Sur la page Pilates le rond passe en orange, celui de la pastille « mon pack ».   */
    /* Demande de Nicolas le 21/09/2026 : « n utilise pas le rouille pour les boutons,   */
    /* utilise le orange, celui de la notification mon pack ». Le + reste blanc pur :    */
    /* le creme #fefcee sur l orange #f2a03d ne se lisait pas sur un telephone.          */
    'body.template--mix-match-pilates .mm-add{background:#f2a03d;color:#ffffff;}',
    'body.template--mix-match-pilates .mm-add:hover,',
    'body.template--mix-match-pilates .mm-add--actif{background:#d98a22;}',
    'body.template--mix-match-pilates .mm-add__txt{background:#ffffff;color:#b56f16;',
    'border-color:#f2a03d;}',
    /* 4. La fenetre de choix de taille. Fond creme, comme le reste du site. */
    '.mm-modal[hidden]{display:none;}',
    '.mm-modal{position:fixed;inset:0;z-index:2147483000;display:flex;',
    'align-items:flex-end;justify-content:center;}',
    '.mm-modal__fond{position:absolute;inset:0;background:rgba(28,24,20,.58);}',
    '.mm-modal__boite{position:relative;width:100%;max-width:420px;background:#fefcee;',
    'border-radius:18px 18px 0 0;padding:22px 20px 26px;text-align:center;',
    'box-shadow:0 -10px 40px rgba(28,24,20,.28);}',
    '.mm-modal__x{position:absolute;top:8px;right:10px;border:0;background:none;',
    'font-size:26px;line-height:1;cursor:pointer;color:#8b8279;padding:6px;}',
    '.mm-modal__x:hover{color:#7d432d;}',
    '.mm-modal__sur{margin:0;font-size:11px;letter-spacing:.14em;text-transform:uppercase;',
    'color:#8b8279;}',
    '.mm-modal__titre{margin:4px 0 16px;font-size:16px;font-weight:600;color:#1c1c1c;}',
    '.mm-modal__tailles{display:flex;flex-direction:column;gap:10px;}',
    /* Le choix de taille est CENTRE (demande de Nicolas du 20/09/2026) : il etait en  */
    /* space-between, ce qui collait le nom de la taille au bord gauche de la pastille */
    /* alors que tout le reste de la fenetre est centre.                               */
    /* 16px mini : en dessous, Safari iOS zoome et la page devient baladable.           */
    '.mm-taille{display:flex;align-items:center;justify-content:center;gap:10px;',
    'min-height:52px;padding:0 18px;border:1px solid #d9cfc2;border-radius:12px;',
    'background:#fefcee;font-size:16px;font-weight:600;color:#1c1c1c;cursor:pointer;',
    'text-align:center;}',
    '.mm-taille:hover:not([disabled]){border-color:#1c1c1c;}',
    '.mm-taille[disabled]{opacity:.4;cursor:not-allowed;}',
    '.mm-taille--prise{border-color:#7d432d;background:rgba(125,67,45,.07);color:#7d432d;}',
    '.mm-taille__n{font-size:12px;font-weight:600;color:#7d432d;}',
    /* 03/10/2026 (v31) : la taille RECOMMANDEE (celle deja au panier) est presentee comme   */
    /* choisie : fond blanc, texte encre, bordure encre de 2 px. Jamais de fond fonce sous   */
    /* un texte fonce (Nicolas : « la taille choisie est illisible »).                       */
    '.mm-taille{-webkit-tap-highlight-color:transparent;}',
    /* Etat touche / focus (Safari iOS garde :focus et :active apres le tap) : meme rendu que la */
    /* taille choisie, jamais un fond sombre du theme sous un texte sombre.                     */
    '.mm-taille:focus,.mm-taille:active{background:#ffffff;color:#1c1c1c;border-color:#1c1c1c;outline:none;}',
    '.mm-taille--reco{background:#ffffff;border:2px solid #1c1c1c;color:#1c1c1c;}',
    '.mm-taille__reco{font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;',
    'color:#1c1c1c;background:#fefcee;border:1px solid #1c1c1c;border-radius:999px;padding:2px 8px;}',
    'html.mm-modal-ouverte{overflow:hidden;}',
    '@media (min-width:640px){.mm-modal{align-items:center;}',
    '.mm-modal__boite{border-radius:18px;}}'
  ].join('');

  (function poserStyle() {
    if (document.getElementById('mm-taille-ajout-css')) return;
    var s = document.createElement('style');
    s.id = 'mm-taille-ajout-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  })();

  /* Les textes de la fenetre, dans les SIX langues du site (le neerlandais ajoute le 25/09/2026 :
     il retombait sur l anglais, Choose your size sur la page ou tournent les pubs NL). */
  var TEXTES = {
    fr: { sur: 'Choisissez la taille', fermer: 'Fermer', ajouter: 'Ajouter ce modèle, choisir la taille',
          panier: 'au panier', modifier: 'Modifier la sélection', reco: 'Votre taille' },
    en: { sur: 'Choose your size', fermer: 'Close', ajouter: 'Add this model, choose a size',
          panier: 'in cart', modifier: 'Change selection', reco: 'Your size' },
    de: { sur: 'Wähle deine Größe', fermer: 'Schließen', ajouter: 'Dieses Modell hinzufügen, Größe wählen',
          panier: 'im Warenkorb', modifier: 'Auswahl ändern', reco: 'Deine Größe' },
    es: { sur: 'Elige tu talla', fermer: 'Cerrar', ajouter: 'Añadir este modelo, elegir talla',
          panier: 'en la cesta', modifier: 'Cambiar selección', reco: 'Tu talla' },
    it: { sur: 'Scegli la taglia', fermer: 'Chiudi', ajouter: 'Aggiungi questo modello, scegli la taglia',
          panier: 'nel carrello', modifier: 'Modifica selezione', reco: 'La tua taglia' },
    nl: { sur: 'Kies je maat', fermer: 'Sluiten', ajouter: 'Voeg dit model toe, kies een maat',
          panier: 'in winkelwagen', modifier: 'Selectie wijzigen', reco: 'Jouw maat' },
    pt: { sur: 'Escolhe o teu tamanho', fermer: 'Fechar', ajouter: 'Adicionar este modelo, escolher o tamanho',
          panier: 'no carrinho', modifier: 'Alterar seleção', reco: 'O teu tamanho' },
    pl: { sur: 'Wybierz swój rozmiar', fermer: 'Zamknij', ajouter: 'Dodaj ten model, wybierz rozmiar',
          panier: 'w koszyku', modifier: 'Zmień wybór', reco: 'Twój rozmiar' }
  };

  function dire(cle) {
    var l = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return (TEXTES[l] || TEXTES.en)[cle];
  }

  /* Le NOM DU MODELE seul, pas le titre complet (demande de Nicolas du 20/09/2026 :
     la fenetre affichait Markus Checkerboard Nordic Socks, il ne veut que Markus).
     Les modeles portent un prenom nordique en tete de titre, et la suite decrit le
     produit. Deux formes selon la langue, d ou les deux separateurs :
       anglais   Markus Checkerboard Nordic Socks   -> espace
       francais  Honninka, chaussettes nordiques    -> virgule
     Pas d expression reguliere ici : on cherche le premier separateur a la main, ce
     qui evite d avoir a compter des antislash dans un fichier qui passe par une API. */
  function nomCourt(titre) {
    var t = String(titre || '').trim();
    /* ⚠️ LA VIRGULE PRIME SUR L ESPACE, et l ordre compte.
       Premiere version : on coupait au premier separateur rencontre, espace ou
       virgule. Consequence vue le 21/09/2026 sur la collection Pilates : « Oat Milk,
       chaussettes de Pilates antiderapantes creme » sortait en « Oat », parce que
       l espace de « Oat Milk » arrive avant la virgule. Tous les modeles a deux mots
       etaient tronques. Les titres francais portent une virgule apres le nom du
       modele, les titres anglais n en ont pas : on cherche donc la virgule d abord,
       et on ne retombe sur l espace que s il n y en a aucune. */
    var virgule = t.indexOf(',');
    if (virgule > 0) return t.slice(0, virgule).trim();
    for (var i = 0; i < t.length; i++) {
      var c = t.charAt(i);
      if (c === ' ' || c === ' ') return t.slice(0, i);
    }
    return t;
  }

  function el(tag, cls, texte) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (texte != null) n.textContent = texte;
    return n;
  }

  function zoneImage(carte) {
    var media = carte.querySelector('.card__media, .card--media, .product-card__media, .media');
    if (!media) { var im = carte.querySelector('img'); media = im ? im.parentElement : null; }
    return media;
  }

  /* ATTENTION, NE PAS REVENIR A UN SELECTEUR D ATTRIBUT ICI.
     Un identifiant de variante est un nombre (41755808497836), et en CSS un
     identifiant ne peut pas commencer par un chiffre : le selecteur
     [product-card-gift-id=41755808497836] sans guillemets leve une SyntaxError.
     Consequence mesuree le 20/09/2026 : l exception coupait la boucle de
     majBoutons des la premiere carte, d ou UN SEUL bouton pose pour 40 produits. */
  function qtePanier(variantId) {
    if (!variantId) return 0;
    var cible = String(variantId);
    /* 29/09/2026 (v28, panier unique) : sur le Mix & Match, le panneau est le miroir du VRAI panier,
       tenu par snippets/mix-bundle-right.liquid dans window.__mmPanierQte (variante -> quantite). */
    if (window.__mmPanierQte) return window.__mmPanierQte[cible] || 0;
    var lignes = document.getElementsByTagName('product-card-gift');
    for (var i = 0; i < lignes.length; i++) {
      if (lignes[i].getAttribute('product-card-gift-id') !== cible) continue;
      var input = lignes[i].querySelector('input[name=quantity]');
      return input ? parseInt(input.value || '0', 10) || 0 : 0;
    }
    return 0;
  }

  /* ================= LE SECOND MODE : LES PAGES COLLECTION =================

     Nicolas, 21/09/2026 : « ce plus la, pour voir les tailles, tu dois le mettre sur
     TOUTES les pages collections. Ce qu on a mis sur Mix and Match, tu dois le mettre
     partout. »

     Ce n est pas qu une histoire de chargement de script. Sur le Mix & Match, ajouter
     une paire veut dire piloter le compteur <quantity-input-mix-match> du pack ; ce
     composant n existe nulle part ailleurs. Sur une page collection ordinaire il faut
     donc un VRAI ajout au panier, et les tailles ne sont pas dans le HTML de la carte :
     elles se lisent sur la fiche produit.

     D ou deux modes, decides carte par carte et jamais par gabarit :
       - mode PACK    : la carte porte un <quantity-input-mix-match>  -> comportement d avant
       - mode PANIER  : elle n en porte pas -> on lit /products/<handle>.js et on POSTe
                        sur /cart/add.js
     Lire le mode sur la CARTE et pas sur le nom du gabarit evite d avoir a tenir une
     liste de templates a jour, et ca marche du premier coup sur une page qu on n avait
     pas prevue. */
  var CATALOGUE = {};   /* url de fiche -> tailles, pour ne telecharger qu une fois */
  var PANIER = {};      /* identifiant de variante -> quantite deja au panier */
  var PANIER_TAILLES = {}; /* libelle de taille (36/38...) -> paires au panier, toutes references confondues */

  function modePack(carte) {
    return !!carte.querySelector('quantity-input-mix-match');
  }

  function urlProduit(carte) {
    var a = carte.querySelector('a[href*="/products/"]');
    if (!a) return null;
    return (a.getAttribute('href') || '').split('?')[0];
  }

  function lirePanierGlobal() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        PANIER = {};
        PANIER_TAILLES = {};
        if (c && c.items) {
          for (var i = 0; i < c.items.length; i++) {
            PANIER[String(c.items[i].id)] = c.items[i].quantity;
            var vt = c.items[i].variant_title;
            if (vt) PANIER_TAILLES[vt] = (PANIER_TAILLES[vt] || 0) + c.items[i].quantity;
          }
        }
        return PANIER;
      })
      .catch(function () { return PANIER; });
  }

  function taillesDistantes(carte) {
    var url = urlProduit(carte);
    if (!url) return Promise.resolve([]);
    if (CATALOGUE[url]) return Promise.resolve(majQtes(CATALOGUE[url]));
    return fetch(url + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (prod) {
        if (!prod || !prod.variants) return [];
        var out = [];
        for (var i = 0; i < prod.variants.length; i++) {
          var v = prod.variants[i];
          out.push({ id: v.id, titre: v.title, prix: v.price, dispo: !!v.available, qte: 0 });
        }
        CATALOGUE[url] = out;
        return majQtes(out);
      })
      .catch(function () { return []; });
  }

  function majQtes(tailles) {
    for (var i = 0; i < tailles.length; i++) {
      tailles[i].qte = PANIER[String(tailles[i].id)] || 0;
    }
    return tailles;
  }

  /* ⚠️ 03/10/2026 (v31) : LE PANIER NE SE METTAIT PAS A JOUR SANS RECHARGER LA PAGE.
     Nicolas l a vu en commande test sur /fr/collections/chaussettes-pilates : la paire entrait
     bien au panier Shopify, mais la bulle de l en-tete restait cachee et le tiroir vide jusqu au
     rafraichissement. Cause : cette fonction emettait « cart:refresh » et « cart:build », deux
     evenements qu AUCUN fichier du theme n ecoute (verifie par recherche dans les 377 fichiers
     texte du theme). On fait maintenant comme le bouton d ajout natif (global.js,
     submitAddToCartForm) : /cart/add avec les sections du tiroir, puis renderContents(r, false)
     (redessine le tiroir SANS l ouvrir) et updateCartCounters() pour la bulle.
     Sur les pages Mix & Match, __mmPanierUnique (snippets/mix-bundle-right.liquid) fait deja ce
     travail et tient le panneau « Mon pack » : on lui passe la main. */
  function tiroirPanier() { return document.querySelector('cart-drawer'); }
  function rafraichirPanierTheme(r) {
    var d = tiroirPanier();
    try { if (d && d.renderContents && r && r.sections) d.renderContents(r, false); } catch (e) {}
    try { if (typeof updateCartCounters === 'function') updateCartCounters(); } catch (e) {}
    try { if (typeof updateFreeShipping === 'function') updateFreeShipping(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('mm:panier-maj')); } catch (e) {}
  }
  function ajouterAuPanier(taille) {
    if (window.__mmPanierUnique && window.__mmPanierUnique.ajouter) {
      return window.__mmPanierUnique.ajouter(taille.id)
        .then(function () { return lirePanierGlobal(); })
        .then(function () {
          try { document.dispatchEvent(new CustomEvent('mm:panier-maj')); } catch (e) {}
          majBoutons();
        });
    }
    var d = tiroirPanier();
    var secs = [];
    try { secs = (d && d.getSectionsToRender ? d.getSectionsToRender() : []).map(function (x) { return x.section; }); } catch (e) { secs = []; }
    var fd = new FormData();
    fd.append('items[0][id]', String(taille.id));
    fd.append('items[0][quantity]', '1');
    if (secs.length) { fd.append('sections', secs.join(',')); fd.append('sections_url', location.pathname); }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (r && (r.status || r.errors) && !r.sections) return;
        rafraichirPanierTheme(r);
      })
      .catch(function () {})
      .then(function () { return lirePanierGlobal(); })
      .then(function () { majBoutons(); });
  }

  function idDe(radio) {
    return radio.value || radio.getAttribute('data-variant-id');
  }

  function taillesDe(carte) {
    var out = [];
    var epuise = carte.classList.contains(CLASSE_EPUISE);
    var wrappers = carte.querySelectorAll('.product-variants .input-wapper');
    for (var i = 0; i < wrappers.length; i++) {
      var radio = wrappers[i].querySelector('.variant-radio');
      var label = wrappers[i].querySelector('.variant-option');
      if (!radio || !label) continue;
      var id = idDe(radio);
      out.push({
        radio: radio,
        id: id,
        titre: radio.getAttribute('data-variant-title') || label.textContent.trim(),
        prix: radio.getAttribute('data-variant-price'),
        qte: qtePanier(id),
        /* radio.disabled n est jamais pose par le theme : c est la carte qui porte
           l information de rupture. Voir l avertissement en tete de fichier. */
        dispo: !epuise && !radio.disabled
      });
    }
    return out;
  }

  function ajouter(carte, taille) {
    /* 29/09/2026 (v28, panier unique) : la paire part DIRECTEMENT au vrai panier Shopify. */
    if (window.__mmPanierUnique && taille && taille.id) {
      window.__mmPanierUnique.ajouter(taille.id).then(function () { majBoutons(); });
      return;
    }
    var qi = carte.querySelector('quantity-input-mix-match');
    if (!qi) return;
    taille.radio.checked = true;
    setTimeout(function () {
      qi.setAttribute('product-var-id', taille.id);
      qi.setAttribute('product-variant', taille.titre);
      if (taille.prix) qi.setAttribute('product-price', taille.prix);
      var input = qi.querySelector('input[name=quantity]');
      var plus = qi.querySelector('button[name=plus]');
      if (!input || !plus) return;
      input.value = qtePanier(taille.id);
      plus.click();
      setTimeout(majBoutons, 120);
    }, 0);
  }

  function majBoutons() {
    var zones = document.querySelectorAll('.product-variants');
    for (var i = 0; i < zones.length; i++) {
      var zone = zones[i];
      var carte = zone.closest(SEL_CARTE);
      if (!carte || !carte.querySelector('quantity-input-mix-match')) continue;

      var btn = carte.querySelector('.mm-add');

      /* Modele epuise : pas de bouton d ajout. L etiquette est celle du theme, voir
         l avertissement en tete de fichier. Laisser le + sur un modele qu on ne peut
         pas acheter ne ferait qu ouvrir une fenetre inutile. */
      if (carte.classList.contains(CLASSE_EPUISE)) {
        if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
        continue;
      }

      if (!btn) {
        var media = zoneImage(carte);
        btn = el('button', 'mm-add');
        btn.type = 'button';
        btn.setAttribute('aria-haspopup', 'dialog');
        btn.appendChild(el('span', 'mm-add__plus', '+'));
        btn.appendChild(el('span', 'mm-add__txt', ''));
        /* Repli sur l ancien emplacement si le theme change de structure : mieux vaut
           un bouton mal place qu aucun bouton. */
        if (media) { media.classList.add('mm-media'); media.appendChild(btn); }
        else { zone.parentNode.insertBefore(btn, zone.nextSibling); }
      }
      var tailles = taillesDe(carte);
      var total = 0;
      for (var j = 0; j < tailles.length; j++) total += tailles[j].qte;
      var txt = btn.querySelector('.mm-add__txt');
      if (!txt) continue;
      if (total > 0) {
        btn.classList.add('mm-add--actif');
        txt.textContent = String(total);
        btn.setAttribute('aria-label', dire('modifier') + ', ' + total + ' ' + dire('panier'));
      } else {
        btn.classList.remove('mm-add--actif');
        txt.textContent = '';
        btn.setAttribute('aria-label', dire('ajouter'));
      }
    }

    posterSurLesCollections();
  }

  /* Le meme + sur les cartes des pages collection, ou il n y a ni .product-variants ni
     compteur de pack. On ne lit RIEN sur le reseau ici : le bouton se pose tout de suite,
     les tailles ne sont telechargees qu au moment ou on l ouvre. Poser 28 requetes au
     chargement d une grille pour un bouton que personne n a encore touche serait absurde. */
  function posterSurLesCollections() {
    var cartes = document.querySelectorAll(SEL_CARTE);
    for (var i = 0; i < cartes.length; i++) {
      var carte = cartes[i];
      if (modePack(carte)) continue;            /* deja traite par la boucle du dessus */
      if (!urlProduit(carte)) continue;         /* pas une carte produit */

      var btn = carte.querySelector('.mm-add');

      if (carte.classList.contains(CLASSE_EPUISE)) {
        if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
        continue;
      }

      if (!btn) {
        var media = zoneImage(carte);
        if (!media) continue;
        btn = el('button', 'mm-add');
        btn.type = 'button';
        btn.setAttribute('aria-haspopup', 'dialog');
        btn.setAttribute('aria-label', dire('ajouter'));
        btn.appendChild(el('span', 'mm-add__plus', '+'));
        btn.appendChild(el('span', 'mm-add__txt', ''));
        media.classList.add('mm-media');
        media.appendChild(btn);
      }

      /* Le compteur en pastille, quand le panier est deja connu. On ne declenche pas de
         lecture reseau pour ca : il se remplit apres le premier ajout, ou apres une
         ouverture de fenetre, qui lisent tous les deux le panier. */
      var url = urlProduit(carte);
      var connues = CATALOGUE[url];
      var txt2 = btn.querySelector('.mm-add__txt');
      if (!connues || !txt2) continue;
      var total2 = 0;
      for (var k = 0; k < connues.length; k++) total2 += PANIER[String(connues[k].id)] || 0;
      if (total2 > 0) {
        btn.classList.add('mm-add--actif');
        txt2.textContent = String(total2);
        btn.setAttribute('aria-label', dire('modifier') + ', ' + total2 + ' ' + dire('panier'));
      } else {
        btn.classList.remove('mm-add--actif');
        txt2.textContent = '';
        btn.setAttribute('aria-label', dire('ajouter'));
      }
    }
  }

  function construireModale() {
    if (modale) return modale;
    modale = el('div', 'mm-modal');
    modale.setAttribute('hidden', '');

    var fond = el('div', 'mm-modal__fond');
    fond.setAttribute('data-fermer', '');

    var boite = el('div', 'mm-modal__boite');
    boite.setAttribute('role', 'dialog');
    boite.setAttribute('aria-modal', 'true');

    var x = el('button', 'mm-modal__x', '×');
    x.type = 'button';
    x.setAttribute('data-fermer', '');
    x.setAttribute('aria-label', dire('fermer'));

    var titre = el('p', 'mm-modal__titre', '');
    titre.id = 'mm-modal-titre';
    boite.setAttribute('aria-labelledby', 'mm-modal-titre');

    boite.appendChild(x);
    boite.appendChild(el('p', 'mm-modal__sur', dire('sur')));
    boite.appendChild(titre);
    boite.appendChild(el('div', 'mm-modal__tailles'));

    modale.appendChild(fond);
    modale.appendChild(boite);
    document.body.appendChild(modale);

    modale.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-fermer]')) fermer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modale && !modale.hasAttribute('hidden')) fermer();
    });
    return modale;
  }

  function fermer() {
    if (!modale) return;
    modale.setAttribute('hidden', '');
    document.documentElement.classList.remove('mm-modal-ouverte');
  }

  function ouvrir(carte, opts) {
    opts = opts || {};
    if (carte.classList.contains(CLASSE_EPUISE)) return;
    var m = construireModale();
    var nom = carte.querySelector('.card__heading, .card__title, .psv2__vignette-nom, h3, h2');
    m.querySelector('.mm-modal__titre').textContent = nom ? nomCourt(nom.textContent) : '';

    var zone = m.querySelector('.mm-modal__tailles');
    zone.textContent = '';

    var pack = modePack(carte);
    var reco = null;

    /* La taille RECOMMANDEE : celle que le panier contient deja (la plus nombreuse), sinon
       l indice passe par l appelant (la taille choisie sur la fiche). Comparee par libelle
       (36/38, 39/41...), donc seulement entre produits qui partagent les memes tailles. */
    function choisirReco(tailles) {
      var noms = {}, n;
      for (n = 0; n < tailles.length; n++) noms[tailles[n].titre] = 1;
      var best = null, bestQ = 0;
      for (var k in PANIER_TAILLES) {
        if (noms[k] && PANIER_TAILLES[k] > bestQ) { best = k; bestQ = PANIER_TAILLES[k]; }
      }
      if (!best && opts.indice && noms[opts.indice]) best = opts.indice;
      return best;
    }

    function peupler(tailles) {
      reco = choisirReco(tailles);
      zone.textContent = '';
      tailles.forEach(function (t) {
        var estReco = !!(reco && t.dispo && t.titre === reco);
        var b = el('button', 'mm-taille' + (t.qte > 0 ? ' mm-taille--prise' : '') + (estReco ? ' mm-taille--reco' : ''));
        b.type = 'button';
        b.disabled = !t.dispo;
        b.appendChild(el('span', 'mm-taille__nom', t.titre));
        if (estReco) b.appendChild(el('span', 'mm-taille__reco', dire('reco')));
        if (t.qte > 0) b.appendChild(el('span', 'mm-taille__n', t.qte + ' ' + dire('panier')));
        b.addEventListener('click', function () {
          var fait = pack ? ajouter(carte, t) : ajouterAuPanier(t);
          if (opts.apres) Promise.resolve(fait).then(function () { opts.apres(t); });
          fermer();
        });
        zone.appendChild(b);
      });
      var premier = zone.querySelector('.mm-taille--reco:not([disabled])') || zone.querySelector('button:not([disabled])');
      if (premier) premier.focus();
    }

    /* La fenetre s ouvre TOUT DE SUITE, meme en mode panier ou les tailles arrivent du
       reseau. Attendre la reponse avant d ouvrir donnerait exactement le symptome que
       Nicolas a decrit sur telephone : « ca charge, mais ca ne fait rien ». */
    m.removeAttribute('hidden');
    document.documentElement.classList.add('mm-modal-ouverte');

    if (pack) {
      peupler(taillesDe(carte));
    } else {
      zone.appendChild(el('p', 'mm-modal__attente', '…'));
      lirePanierGlobal()
        .then(function () { return taillesDistantes(carte); })
        .then(function (tailles) {
          if (modale.hasAttribute('hidden')) return;
          if (!tailles.length) { fermer(); var a = carte.querySelector('a[href*="/products/"]'); if (a) location.href = a.href; return; }
          peupler(tailles);
        });
    }
  }

  /* 03/10/2026 (v31) : le rail « Completer le sac » de la fiche produit (assets/ps-fiche-v2.js)
     ouvre CETTE fenetre au lieu d ajouter une taille au hasard. Il passe la vignette (qui porte
     le lien du produit et son nom), l indice de taille (celle choisie sur la fiche) et un rappel. */
  window.__mmChoisirTaille = function (vignette, opts) {
    if (!vignette) return false;
    ouvrir(vignette, opts || {});
    return true;
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.mm-add') : null;
    if (!btn) return;
    var carte = btn.closest(SEL_CARTE);
    if (carte) {
      e.preventDefault();
      e.stopPropagation();
      ouvrir(carte);
    }
  });

  function brancher() {
    majBoutons();

    var differe = null;
    var replanifier = function () {
      clearTimeout(differe);
      differe = setTimeout(majBoutons, 60);
    };

    /* Plusieurs grilles possibles : le Mix & Match, une page collection ordinaire, et
       le chargement progressif de certaines collections. On les observe toutes. */
    var grilles = document.querySelectorAll(
      '.collection__grid, [data-mix-match-bundle-main-items], .collection-grid-container'
    );
    for (var g = 0; g < grilles.length; g++) {
      new MutationObserver(replanifier).observe(grilles[g], { childList: true, subtree: true });
    }

    var panier = document.querySelector('[data-bundle-main]');
    if (panier) {
      new MutationObserver(replanifier).observe(panier, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['value']
      });
      panier.addEventListener('click', replanifier);
      panier.addEventListener('change', replanifier);
    }

    var n = 0;
    var t = setInterval(function () { majBoutons(); if (++n > 12) clearInterval(t); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brancher);
  } else {
    brancher();
  }
})();
